<template>
  <div class="charts">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="chart-element">
            <div class="d-flex chart-title">
              <h5>Aulas Teóricas <span>- {{qtdTeoricasFeitas}}/{{qtdTeoricasTotal}}</span></h5>
            </div>
            <div class="container-fluid">
              <div class="extra">
                <DonutChartDataAulasTeoricas class="mychart"></DonutChartDataAulasTeoricas>
                <div class="row extra-data">
                  <div class="extra-data-props-r"><h5>{{qtdTeoricasFeitas}}</h5></div>
                  <div class="extra-data-props-l"><h5>{{qtdTeoricasFaltantes}}</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="chart-element">
            <div class="d-flex chart-title">
              <h5>Aulas Práticas <span>- {{qtdPraticasFeitas}}/{{qtdPraticasTotal}}</span></h5>
            </div>
            <div class="container-fluid">
              <div class="extra">
                <DonutChartAulasPraticas class="mychart"></DonutChartAulasPraticas>
                <div class="row extra-data">
                  <div class="extra-data-props-r"><h5>{{qtdPraticasFeitas}}</h5></div>
                  <div class="extra-data-props-l"><h5>{{qtdPraticasFaltantes}}</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="chart-element">
            <div class="d-flex chart-title">
              <h5>Faltas</h5>
            </div>
            <div class="container">
              <DonutChartDataFaltas class="mychart"></DonutChartDataFaltas>
              <h5 class="extra-data">{{qtdFaltas}}</h5>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="chart-bar">
            <div class="d-flex chart-title">
              <h5>Aulas por conteúdo</h5>
            </div>
            <div class="container">
              <BarChartConteudoAulas class="mychart"></BarChartConteudoAulas>
              <h5 class="extra-data">{{qtdCtd}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BadgeColumn from 'components/tables/BadgeColumn.vue'
import DonutChartDataAulasTeoricas from './data/DonutChartAulasTeoricas'
import DonutChartAulasPraticas from './data/DonutChartAulasPraticas'
import DonutChartDataFaltas from './data/DonutChartFaltas'
import BarChartConteudoAulas from './data/BarChartConteudoAulas'
import urlApi from '../../../router/urlApi'
import { mixins } from 'vue-chartjs'

Vue.component('badge-column', BadgeColumn)

const { reactiveProps } = mixins

export default {
  name: 'data-charts-profile',
  components: {
    DonutChartAulasPraticas,
    DonutChartDataAulasTeoricas,
    DonutChartDataFaltas,
    BarChartConteudoAulas
  },
  data: () => {
    return {
      qtdTeoricasFeitas: 0,
      qtdTeoricasFaltantes: 0,
      qtdTeoricasTotal: 45,
      qtdPraticasFeitas: 0,
      qtdPraticasFaltantes: 0,
      qtdPraticasTotal: 21,
      qtdFaltas: 0,
      qtdCtd: 0,
      primeirosSocorros: 0,
      legislacao: 0,
      meioAmbiente: 0,
      direcaoDefensiva: 0,
      tipoAlunoT: false,
      tipoAlunoP: false,
      tipoAlunoI: false,
      tipoAlunoRn: false,
      tipoAlunoRc: false,
      loaded: false,

    }
  },
  mounted () {
    this.extraDataPraticas()
    this.extraDataTeoricas()
    this.extraDataFaltas()
    this.extraDataCtd()
  },
  methods: {
    async extraDataPraticas () {
      await Vue.http.get(urlApi + '/ead/profile').then((response) => {
        this.qtdPraticasFeitas = response.body.aulas_praticas.presencas_aulas_praticas
        this.qtdPraticasTotal = 21
        this.qtdPraticasFaltantes = 0
      })
    },
    async extraDataTeoricas () {
      await Vue.http.get(urlApi + '/ead/profile').then((response) => {
        this.qtdTeoricasFeitas = response.body.aulas_teoricas.presencas_aulas_teoricas
        this.qtdTeoricasFaltantes = this.qtdTeoricasTotal - response.body.aulas_teoricas.presencas_aulas_teoricas // 45 é a soma de todos os conteudos
        this.qtdTeoricasTotal = 45
      })
    },
    async extraDataFaltas () {
      await Vue.http.get(urlApi + '/ead/profile').then((response) => {
        this.qtdFaltas = response.body.aulas_praticas.faltas_aulas_praticas + response.body.aulas_teoricas.faltas_aulas_teoricas
      })
    },
    async extraDataCtd () {
      await Vue.http.get(urlApi + '/ead/profile').then((response) => {
        this.primeirosSocorros = response.body.materias_teoricas.primeiros_socorros
        this.legislacao = response.body.materias_teoricas.legislacao_de_transito
        this.meioAmbiente = response.body.materias_teoricas.protecao_respeito
        this.direcaoDefensiva = response.body.materias_teoricas.direcao_defensiva
        this.qtdCtd = this.primeirosSocorros + this.legislacao + this.meioAmbiente + this.direcaoDefensiva
      })
    },
    // async tipoAluno() {
    //    await Vue.http.get(urlApi + '/ead/profile').then((response) => {
    //     this.tipoAlunoT = response.body.aluno.tipo_aluno.teorico
    //     this.tipoAlunoP = response.body.aluno.tipo_aluno.pratico
    //     this.tipoAlunoI = response.body.aluno.tipo_aluno.inclusao
    //     this.tipoAlunoRn = response.body.aluno.tipo_aluno.renovacao
    //     this.tipoAlunoRc = response.body.aluno.tipo_aluno.reciclagem

    //     if(this.tipoAlunoT == true){

    //     }else if(this.tipoAlunoP == true){

    //     }else if(this.tipoAlunoI == true){

    //     }else if(this.tipoAlunoRn == true){

    //     }else if(this.tipoAlunoRc == true)[

    //     ]
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
  .charts{
    width: 100%;
    height: auto;
  }
  .chart-element{
    margin-left: 5%;
    width: 100%;
  }
  .chart-bar{
    margin-left: 2%;
    width: 100%;
  }
  .extra{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .extra-data{
    color: #d0d0d0;
  }
  .extra-data-props-l{
    padding-left: 0px;
  }
  .extra-data-props-r{
    margin-right: 100px;
  }
  .mychart {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      height: 100%;
      width: 100%;
    }

    canvas {
      width: 100%;
      height: auto;
    }
  }
</style>
